/**
 * A special value that can appear
 * in unions indicating that a value is neither
 * present or absent, but is unknown (for now)
 */
export const LOADING = Symbol(`@kosmod/kit/loading`);
export type LOADING = typeof LOADING;